import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useGetStudentsWithoutVirtualGroupQuery} from "../store/chair/chairApi";
import copyObject from "../utils/copyObject";

export default function StudentsWithoutVirtualGroupPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const {data} = useGetStudentsWithoutVirtualGroupQuery();
    const [copyOfData, setCopyOfData] = useState([]);

    useEffect(() => {
        if (!data?.data)
            return;
        
        setCopyOfData(copyObject(data.data).sort((l,r) => l.value > r.value ? 1 : l.value === r.value ? (l.key > r.key ? 1 : -1) : -1));
    }, [data]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };

    return (
        <GeneralLayout>
            <PageTitle title={`Студенты без сводной группы`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Студенты без сводной группы
                        </Typography>
                    </Stack>

                    <Card>
                        <Table size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ФИО</TableCell>
                                    <TableCell>Группа</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {copyOfData?.map((item) => {
                                    return <TableRow>
                                        <TableCell>{item.key}</TableCell>
                                        <TableCell>{item.value}</TableCell>
                                    </TableRow>
                                })
                                }
                            </TableBody>
                        </Table>
                    </Card>

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}